import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=5d09cd0a&"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts&"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts&"
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports